import { useSyncExternalStore } from 'react';
import {
    getServerUnreadNotifications,
    getUnreadNotifications,
    subscribeToUnreadNotifications
} from '../notifications/unread-notifications-store';

/** Re-renders whenever the customer's unread count changes, wherever the change came from. */
export function useUnreadNotifications(): number {
    return useSyncExternalStore(
        subscribeToUnreadNotifications,
        getUnreadNotifications,
        getServerUnreadNotifications
    );
}
